import { render, staticRenderFns } from "./AssignConfirmModal.vue?vue&type=template&id=24a78f8c&scoped=true&"
import script from "./AssignConfirmModal.vue?vue&type=script&lang=js&"
export * from "./AssignConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignConfirmModal.vue?vue&type=style&index=0&id=24a78f8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a78f8c",
  null
  
)

export default component.exports